var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { Getter, namespace } from "vuex-class";
import { RobCaseService } from "~/services/domain-service/rob-case.service.ts";
import { SortService } from "~/utils/sort.service";
import RobberyComponents from "~/components/common-manages/robbery-components.vue";
import FollowUpRecordCommon from "~/components/common-manages/follow-up-record-common.vue";
import NumberRange from "~/components/common/number-range.vue";
import { MENU_CHANNEL } from "~/config/enum.config";
import RepairCaseDistrubute from "~/components/common-manages/credit-repair-case/repair-case-distrubute.vue";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
var CollectionExecutionModule = namespace("collection-execution");
var RobberyCase = /** @class */ (function (_super) {
    __extends(RobberyCase, _super);
    function RobberyCase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectionList = [];
        _this.caseIds = [];
        _this.roleModel = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            deptIds: [],
            area: "",
            currentCollectorRealName: "",
            customerCategory: "",
            overdueAmount: {
                // 欠款金额
                max: "",
                min: ""
            },
            caseMoney: { min: "", max: "" },
            overduePeriod: "",
            overdueDays: {
                max: "",
                min: ""
            },
            followupBack: "",
            turnSource: "",
            productCategory: "",
            productName: "",
            followInTime: [],
            labelName: []
        };
        _this.followUpId = ""; // 跟进id
        _this.roleDataSet = [];
        _this.roleObj = {};
        _this.dialog = {
            distrubute: false,
            robbery: false,
            followrecordShow: false //  跟进记录
        };
        _this.robberyCaseTrue = true;
        return _this;
    }
    /**
     * 获取案件数据
     */
    RobberyCase.prototype.refreshData = function () {
        var _this = this;
        this.robCaseService
            .robCasesQuery(this.roleModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.roleDataSet = data;
            _this.selectionList = [];
        });
    };
    /**
     * 范围输入框的重置
     */
    RobberyCase.prototype.handleResetForm = function () {
        this.roleModel.overdueAmount = { min: "", max: "" };
        this.roleModel.overdueDays = { max: "", min: "" };
        this.roleModel.caseMoney = { min: "", max: "" };
    };
    /**
     * 点击抢案
     */
    RobberyCase.prototype.robberyClick = function () {
        if (this.selectionList.length <= 0) {
            this.$message.info("请先选择案件");
            return;
        }
        this.caseIds = this.selectionList.map(function (v) { return v.id; });
        this.dialog.robbery = true;
    };
    /**
     * 点击 跟进记录
     */
    RobberyCase.prototype.followrecordsclick = function (row) {
        this.followUpId = row.id;
        this.dialog.followrecordShow = true;
    };
    /**
     * 行动代码
     */
    RobberyCase.prototype.setCheckTime = function () {
        if (!this.roleModel.followupBack) {
            this.roleModel.checkTime = "";
        }
        if (this.roleModel.followupBack === "PTP" ||
            this.roleModel.followupBack === "CAPT") {
            var currentTime = new Date();
            this.roleModel.checkTime = this.$filter.dateTimeFormat(new Date((currentTime / 1000 + 86400 * 3) * 1000));
        }
        else {
            var currentTime = new Date();
            this.roleModel.checkTime = this.$filter.dateTimeFormat(new Date((currentTime / 1000 + 86400) * 1000));
        }
    };
    /**
     * 进入查看执行页
     */
    RobberyCase.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Case_of_robbery,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    RobberyCase.prototype.mounted = function () {
        this.refreshData();
    };
    /**
     *  点击分案
     */
    RobberyCase.prototype.manualDistruibute = function () {
        if (this.selectionList.length === 0) {
            this.$message("请选择要分配的案件");
        }
        else {
            this.robberyCaseTrue = true;
            this.dialog.distrubute = true;
        }
    };
    __decorate([
        Dependencies(PageService)
    ], RobberyCase.prototype, "pageService", void 0);
    __decorate([
        Dependencies(RobCaseService)
    ], RobberyCase.prototype, "robCaseService", void 0);
    __decorate([
        Dependencies(SortService)
    ], RobberyCase.prototype, "sortService", void 0);
    __decorate([
        Getter
    ], RobberyCase.prototype, "departmentData", void 0);
    __decorate([
        CollectionExecutionModule.Action
    ], RobberyCase.prototype, "openCollectionExecution", void 0);
    RobberyCase = __decorate([
        Auth(1801),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                RobberyComponents: RobberyComponents,
                NumberRange: NumberRange,
                FollowUpRecordCommon: FollowUpRecordCommon,
                RepairCaseDistrubute: RepairCaseDistrubute
            }
        })
    ], RobberyCase);
    return RobberyCase;
}(Vue));
export default RobberyCase;
